import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { bootstrapUserSession, loginApi } from "../api/auth";
import { getDashboardPathFromToken } from "../utils/dashboardRouting";

const LoginPage = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [failed, setFailed] = useState(false);
    const [loading, setLoading] = useState(false);

    // 🔁 If already logged in, go to dashboard
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const cachedUser = localStorage.getItem("user");
                const cachedMapping = localStorage.getItem("userMapping");
                const needsSessionBootstrap =
                    !cachedUser ||
                    !cachedMapping ||
                    !JSON.parse(cachedUser || "{}")?.assignedCenterId;

                if (needsSessionBootstrap) {
                    bootstrapUserSession(token).catch(() => null);
                }
                navigate(getDashboardPathFromToken(token), { replace: true });
            } catch (error) {
                localStorage.removeItem("token");
            }
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setFailed(false);
        setLoading(true);

        try {
            const res = await loginApi({ email, password });

            localStorage.setItem("token", res.token);

            try {
                await bootstrapUserSession(res.token);
            } catch (err) {
                console.warn("Failed to fetch user session details, continuing with token only");
            }

            navigate(getDashboardPathFromToken(res.token), { replace: true });

        } catch (err) {
            console.error(err);
            setFailed(true);
            setLoading(false);
        }
    };

    return (
        <>
            <div className="auth-box overflow-hidden align-items-center d-flex">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-md-6 col-sm-8">

                            {/* Brand */}
                            <div className="auth-brand text-center mb-4">
                                <img
                                    style={{ height: "4rem" }}
                                    src="https://erp.empowerplus.in/files/ep%20logo.png"
                                    alt="logo"
                                />
                                <h4 className="fw-bold mt-3">Welcome</h4>
                                <p className="text-muted w-lg-75 mx-auto">
                                    Let’s get you signed in. Enter your email and password to continue.
                                </p>
                            </div>

                            {/* Card */}
                            <div className="card p-4 rounded-4">
                                <form onSubmit={handleLogin}>

                                    {/* Email */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Email address <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="you@example.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            disabled={loading}
                                        />
                                    </div>

                                    {/* Password */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Password <span className="text-danger">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control pe-5"
                                                placeholder="••••••••"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                                disabled={loading}
                                            />
                                            <span
                                                onClick={() => !loading && setShowPassword(!showPassword)}
                                                className="position-absolute end-0 top-50 translate-middle-y me-3"
                                                style={{ cursor: loading ? "default" : "pointer" }}
                                            >
                                                <i
                                                    className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"} fs-20`}
                                                ></i>
                                            </span>
                                        </div>
                                    </div>

                                    {/* Error */}
                                    {failed && (
                                        <div className="text-danger mb-3">
                                            Invalid email or password. Please try again.
                                        </div>
                                    )}

                                    {/* Button */}
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn btn-primary fw-semibold py-2"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    Signing in…
                                                </>
                                            ) : (
                                                "Sign In"
                                            )}
                                        </button>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginPage;



// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { login } from "../api/auth";
// import { jwtDecode } from "jwt-decode";


// const LoginPage = () => {
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [failed, setFailed] = useState(false);
//     const navigate = useNavigate();
//     const [showPassword, setShowPassword] = useState(false);

//     // ⛔️ Redirect to proper dashboard if already logged in
//     useEffect(() => {
//         const token = localStorage.getItem("token");
//         if (token) {
//             try {
//                 const decoded = jwtDecode(token);
//                 const role = decoded?.authorities?.[0];
//                 redirectToDashboard(role);
//             } catch (e) {
//                 localStorage.removeItem("token"); // remove invalid token
//             }
//         }
//     }, [navigate]);

//     // ✅ Role-based redirect function
//     const redirectToDashboard = (role) => {
//         switch (role) {
//             case "ROLE_ADMIN":
//                 navigate("/dashboard");
//                 break;
//             case "ROLE_PM":
//                 navigate("/dashboard");
//                 break;
//             case "ROLE_PC":
//                 navigate("/pc/dashboard");
//                 break;
//             case "ROLE_USER":
//                 navigate("/user/dashboard");
//                 break;
//             default:
//                 navigate("/dashboard");
//         }
//     };

//     const handleLogin = async (e) => {
//         e.preventDefault();

//         try {
//             const response = await login(email, password);
//             const token = response.token;
//             localStorage.setItem("token", token);

//             const decoded = jwtDecode(token);
//             const role = decoded?.authorities?.[0];

//             redirectToDashboard(role);
//         } catch (error) {
//             alert("Login failed");
//             setFailed(true);
//             console.error(error);
//         }
//     };

//     return (
//         <>

//             <div class="auth-box overflow-hidden align-items-center d-flex">
//                 <div class="container">
//                     <div class="row justify-content-center">
//                         <div class="col-xxl-4 col-md-6 col-sm-8">
//                             <div class="auth-brand text-center mb-4">
//                                 <img style={{ height: "4rem" }} src="https://erp.empowerplus.in/files/ep%20logo.png"
//                                     alt="logo" />
//                                 <h4 class="fw-bold mt-3">Welcome</h4>
//                                 <p class="text-muted w-lg-75 mx-auto">Let’s get you signed in. Enter your email and password to
//                                     continue.</p>
//                             </div>

//                             <div class="card p-4 rounded-4">

//                                 <form onSubmit={handleLogin}>
//                                     <div class="mb-3">
//                                         <label for="userEmail" class="form-label">Email address <span
//                                             class="text-danger">*</span></label>
//                                         <div class="input-group">
//                                             <input type="email" value={email} class="form-control"
//                                                 placeholder="you@example.com" onChange={(e) => setEmail(e.target.value)} required />
//                                         </div>
//                                     </div>

//                                     <div className="mb-3">
//                                         <label htmlFor="userPassword" className="form-label">
//                                             Password <span className="text-danger">*</span>
//                                         </label>
//                                         <div className="position-relative">
//                                             <input
//                                                 type={showPassword ? "text" : "password"}
//                                                 value={password}
//                                                 className="form-control pe-5" // add padding to the end
//                                                 onChange={(e) => setPassword(e.target.value)}
//                                                 placeholder="••••••••"
//                                                 required
//                                             />
//                                             <span
//                                                 onClick={() => setShowPassword(!showPassword)}
//                                                 className="position-absolute end-0 top-50 translate-middle-y me-3"
//                                                 style={{ cursor: "pointer" }}
//                                             >
//                                                 <i className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"} fs-20`}></i>
//                                             </span>
//                                         </div>
//                                     </div>

//                                     {/* <div class="d-flex justify-content-end align-items-end mb-3">
//                                         <div class="form-check">
//                                             <input class="form-check-input form-check-input-light fs-14" type="checkbox"
//                                                 id="rememberMe" />
//                                             <label class="form-check-label" for="rememberMe">Keep me signed in</label>
//                                         </div>
//                                         <a href="auth-reset-pass.html"
//                                             class="text-decoration-underline link-offset-3 text-muted">Forgot Password?</a>
//                                     </div> */}

//                                     {failed ? <> <div class="text-danger mb-4" style={{ display: "block" }}>Invalid email or password
//                                     </div></> : <></>}

//                                     <div class="d-grid">
//                                         <button type="submit" class="btn btn-primary fw-semibold py-2">Sign In</button>
//                                     </div>
//                                 </form>


//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </>
//         // <div style={{ margin: "20px" }}>
//         //     <h2>Login</h2>
//         //     <form onSubmit={handleLogin}>
//         //         <input
//         //             type="email"
//         //             value={email}
//         //             placeholder="Email"
//         //             onChange={(e) => setEmail(e.target.value)}
//         //             required
//         //         />
//         //         <br />
//         //         <input
//         //             type="password"
//         //             value={password}
//         //             placeholder="Password"
//         //             onChange={(e) => setPassword(e.target.value)}
//         //             required
//         //         />
//         //         <br />
//         //         <button type="submit">Login</button>
//         //     </form>
//         // </div>
//     );
// };

// export default LoginPage;


// // import { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { login } from "../api/auth";
// // import { jwtDecode } from "jwt-decode";

// // const LoginPage = () => {
// //     const [email, setEmail] = useState("");
// //     const [password, setPassword] = useState("");
// //     const navigate = useNavigate();

// //     // ⛔️ If already logged in, redirect to dashboard
// //     useEffect(() => {
// //         const token = localStorage.getItem("token");
// //         if (token) {
// //             try {
// //                 jwtDecode(token); // try decoding
// //                 navigate("/dashboard");
// //             } catch (e) {
// //                 localStorage.removeItem("token"); // remove invalid token
// //             }
// //         }
// //     }, [navigate]);

// //     const handleLogin = async (e) => {
// //         e.preventDefault();

// //         try {
// //             const response = await login(email, password);
// //             const token = response.token;
// //             localStorage.setItem("token", token);
// //             navigate("/dashboard");
// //         } catch (error) {
// //             alert(error);
// //             console.error(error);
// //         }
// //     };

// //     return (
// //         <div style={{ margin: "20px" }}>
// //             <h2>Login</h2>
// //             <form onSubmit={handleLogin}>
// //                 <input
// //                     type="email"
// //                     value={email}
// //                     placeholder="Email"
// //                     onChange={(e) => setEmail(e.target.value)}
// //                     required
// //                 />
// //                 <br />
// //                 <input
// //                     type="password"
// //                     value={password}
// //                     placeholder="Password"
// //                     onChange={(e) => setPassword(e.target.value)}
// //                     required
// //                 />
// //                 <br />
// //                 <button type="submit">Login</button>
// //             </form>
// //         </div>
// //     );
// // };

// // export default LoginPage;
